import React from "react";
import RadialGauge from "./RadialGauge";

const AnalogCard = ({ tag, latestMap, min = 0, max = 100, unit = "" }) => {
  const latest = latestMap?.[tag.name];

  const numeric =
    latest && latest.last_value !== null && latest.last_value !== undefined && !isNaN(latest.last_value)
      ? Number(latest.last_value)
      : null;

  const valueText = numeric !== null ? numeric.toFixed(2) : "N/A";
  const ts = latest?.timestamp ?? "N/A";
  const gaugeVal = numeric !== null ? numeric : (min + max) / 2;

  return (
    <div className="dg-card">
      <div className="dg-card-head">
        <div className="dg-card-title">{tag.name}</div>
        <div className="dg-card-sub">ID: {tag.id}</div>
      </div>

      <RadialGauge
        value={gaugeVal}
        min={min}
        max={max}
        label={numeric !== null ? `${valueText}${unit}` : "N/A"}
      />

      <div className="dg-row">
        <span className="dg-label">Value</span>
        <span className="dg-value-strong">
          {valueText}
          {unit}
        </span>
      </div>

      <div className="dg-row">
        <span className="dg-label">Timestamp</span>
        <span className="dg-value-soft">{ts}</span>
      </div>
    </div>
  );
};

export default AnalogCard;